import p5 from 'p5';
import React, { useEffect, useState } from 'react'
import Sketch from "react-p5";
import "./Cnn2.css"
function Cnn2() {
    let ml5;
    
    let [guess,setGuess]=useState("");
    let [bstate,setBstate]=useState();
    let p5_loc;
    let rSlider;
    let gSlider;
    let bSlider;

    let cat={};
    let train={};
    let rain={};
    let camel={};

    let  canvas;
    let string_dict=["CAT","TRAIN","RAINBOW","CAMEL"]


    const cat_category=0
    const train_category=1
    const rain_category=2
    const camel_category=3

    const len=784;
    const total_img=1000;

    let canvas_width=500;
    console.log(window.screen.availHeight)
    canvas_width=window.screen.availWidth>420?400:300;


    let brain;
    const setup = (p5, canvasParentRef) => {
        canvas=p5.createCanvas(canvas_width, canvas_width).parent(canvasParentRef)
        p5_loc=p5;
        p5.pixelDensity(1);


        // rSlider=p5.createSlider(0,255,0);
        // rSlider.position(650+100,50);
        //  gSlider=p5.createSlider(0,255,0);
        // gSlider.position(650+100,150);
        //  bSlider=p5.createSlider(0,255,0);
        // bSlider.position(650+100,250);

        p5.noFill();
        p5.stroke(0);
        p5.rect(0,0,canvas_width,canvas_width);
        p5.background(0);
       
   
//new
        // let total=0;
        // let temp_data=cat_data;
        // temp_data=train_data;
        // temp_data=camel_data;
        // temp_data=rain_data;
        // for(let n=0;n<total;n++)
        // {
        //     let x=(n%10)*28;
        //     let y=Math.floor(n/10)*28;
        //     p5.loadPixels();
        //     let val1=255;
        //     let val2=0;
        //     let val3=0;
        //     let ind=y*p5.width+x;
        //     p5.pixels[ind*4+0]=val1;
        //     p5.pixels[ind*4+1]=val2;
        //     p5.pixels[ind*4+2]=val3;
        //     p5.pixels[ind*4+3]=255;
        //     draw_img_at(x,y,ind,temp_data,n);
        //     p5.updatePixels();
        // }
    
    console.log("finish setup");
    // data_display2();
    prepareData(cat,cat_data,0.8,0);
    prepareData(train,train_data,0.8,1);
    prepareData(rain,rain_data,0.8,2);
    prepareData(camel,camel_data,0.8,3);
    
        // console.log(cat);
        // console.log(camel);

    console.log("after debug");

    let options = {
        inputs:[28,28,4],
        debug: true,
        task: 'imageClassification',
       
    }
    brain=ml5.neuralNetwork(options);
    
    let all_training=[]
    all_training=all_training.concat(cat.train);
    all_training=all_training.concat(train.train);
    all_training=all_training.concat(rain.train);
    // all_training=all_training.concat(camel.train);
    
    p5.shuffle(all_training,true);
    
    for (let i=0;i<all_training.length;i++)
    {
        // let inputs=all_training[i];
        let label=all_training[i].label;
        // console.log(inputs);
        // console.log(label);
        let targets=[0,0,0,0];
        targets[label]=1
        // brain.addData(inputs,label);
    
    
        // // console.log(brain.data);
    
        let ip1=all_training[i];
        // console.log(ip1)
        // console.log(ip1.length);
        let label_temp=all_training[i].label;
        let ri=[]
        for(let j=0;j<28;j++)
        {
            for(let k=0;k<28;k++)
            {
                let itemp=j*28+k;
                ri[itemp*4+0]=ip1[itemp];
                ri[itemp*4+1]=ip1[itemp];
                ri[itemp*4+2]=ip1[itemp];
                ri[itemp*4+3]=255;
            }
        }
        // console.log(ri);
        // console.log(ri.length);
        // console.log(label_temp);
        // brain.addData({image:ri},{label:targets});
        brain.addData({image:ri},{label:string_dict[label_temp]});
        
        // console.log(ip1);
        // console.log(targets);

        // brain.addData(ip1,targets);     //for normal classification
    }

    // brain.normalizeData();
    // console.log(brain);
    console.log(brain.data);

    
    // p5.image(dum3,0,280)
    console.log(dum3);
    // brain.addData({image:dum3,label:"dummy3"});

    let yop=[[1,4],[5,6,7]]
    console.log(yop)
    console.log(yop.length)

    loadbtn();

    //end of setup

    }
    
    
    let adddata_brain = (data)=>{
        // for(let i=0;i<data.train.length;i++)
        for(let i=0;i<2;i++)
        {
            let ig=p5_loc.createImage(28,28);

            let inp=data.train[i];
            //inp is 28*28 with label
            let refine_inp=[]
            for(let j=0;j<28;j++)
            {
                for(let k=0;k<28;k++)
                {
                    let ind=i*28+j;
                    ig.pixels[ind*4+0]=inp[ind]
                    ig.pixels[ind*4+1]=inp[ind]
                    ig.pixels[ind*4+2]=inp[ind]
                    ig.pixels[ind*4+3]=255
                }
            }
            brain.addData({image:ig},{label:inp.label});
            console.log(brain.data);
            // console.log(inp.label)
            console.log(ig)
        }
        console.log("one train over");
    }

    let prepareData=(category, data, num,label)=>{
        category.train=[]
        category.testing=[]
        let cutoff=Math.floor((num*total_img));
        category.cutoff=cutoff;
        for(let i=0;i<total_img;i++)
        {
            let offset=i*len;
            let val=data.bytes.slice(offset,offset+len);
            if(i<cutoff)
            {
                //add to train
                category.train[i]=val;
                category.train[i].label=label;
            }
            else{
                //add to test
                category.testing[i-cutoff]=val;
                category.testing[i-cutoff].label=label;
            }
                   }
    }

   

    let draw_img_at = (x,y,ind,data,n)=>{
        let img2=p5_loc.createImage(28,28);
        for(let i=0;i<28;i++)
        {
            for(let j=0;j<28;j++)
            {
                let cc=i*28+j;
                let id=(y+i)*p5_loc.width+(x+j);
                let val2=data.bytes[n*28*28+(i*28+j)];
                val2=255-val2;
                p5_loc.pixels[id*4+0]=val2;
                p5_loc.pixels[id*4+1]=val2;
                p5_loc.pixels[id*4+2]=val2;
                p5_loc.pixels[id*4+3]=255;
                
                let id2=(i)*28+(j);
                // p5_loc.loadPixels(img2);
                // img2.pixels[id2*4 +0]=100000000;
                // img2.pixels[id2*4 +1]=val2;
                // img2.pixels[id2*4 +2]=val2;
                // img2.pixels[id2*4 +3]=255;
                // p5_loc.updatePixels(img2);
                // p5_loc.image(img2,0,0);
            }
        
        }
        console.log("this is img2");
        console.log(img2);

        
    }
      
    let dc=0;
      const draw = p5 => {
        p5_loc=p5;
        if(p5.mouseIsPressed)
        {
            p5.strokeWeight(15)  
            p5.stroke(255,255,255);
            p5.line(
            p5.mouseX,
            p5.mouseY,
            p5.pmouseX,
            p5.pmouseY,
            )
        }

        if(dc%100==0)
        {
            // console.log(brain)
        }
        dc++;

      }
    
    
    let rain_data;
    let camel_data;
    let cat_data;
    let train_data;

    let dum3;
    
    // let input;
    let keyPressed = p5 =>{
        // p5.clear();
        // p5.background(0);

        let input=p5.createGraphics(28,28);
        input.copy(canvas,0,0,canvas_width,canvas_width,0,0,28,28);
        p5.image(input,0,0)
        // console.log("key is presed");
        // // cons
        // p5.loadPixels();
        // let test_data=p5.pixels

    }
        let preLoad = p5 =>{

        let data_val="data_public"
        rain_data=p5.loadBytes(`./${data_val}/rain_1000.bin`);

        train_data=p5.loadBytes(`./${data_val}/train_1000.bin`);
        
        cat_data=p5.loadBytes(`./${data_val}/cat_1000.bin`);
        
        camel_data=p5.loadBytes(`./${data_val}/camel_1000.bin`);
        dum3=p5.loadImage("./snow_mountain.jpg");
           
        

    } 

    let data_display2= () =>{
        console.log(rain_data.bytes);
        console.log(train_data.bytes);
        console.log(cat_data.bytes);
        console.log(camel_data.bytes);
        // console.log(camel_data);
    }


    useEffect(()=>{
        // preLoad();
        ml5=window.ml5


    },[])


    let img_on=false
    let c_loc=0;
    let imgbtn = () => {
        brain.normalizeData();
        console.log(brain.data);
    }
    let databtn = () => {
        // brain.normalizeData();
        console.log(brain.data);
    }
    let trainbtn = () => {
        brain.train({epochs:50},finishedTraining);
     
    }

    let testbtn = ()=>{
        let ip1=cat.testing[0];
        let ri=[]
        for(let j=0;j<28;j++)
        {
            for(let k=0;k<28;k++)
            {
                let itemp=j*28+k;
                ri[itemp*4+0]=ip1[itemp];
                ri[itemp*4+1]=ip1[itemp];
                ri[itemp*4+2]=ip1[itemp];
                ri[itemp*4+3]=255;
            }
        }
        //brain=bstate;
        console.log(ri);
        brain.classify(ri,overtest);
    }
    let testbtn2 = ()=>{
        let ip1=train.testing[0];
        let ri=[]
        for(let j=0;j<28;j++)
        {
            for(let k=0;k<28;k++)
            {
                let itemp=j*28+k;
                ri[itemp*4+0]=ip1[itemp];
                ri[itemp*4+1]=ip1[itemp];
                ri[itemp*4+2]=ip1[itemp];
                ri[itemp*4+3]=255;
            }
        }
        //brain=bstate;
        console.log(ri);
        brain.classify(ri,overtest);
    }

    let testbtn3 = ()=>{
        let ip1=rain.testing[0];
        let ri=[]
        for(let j=0;j<28;j++)
        {
            for(let k=0;k<28;k++)
            {
                let itemp=j*28+k;
                ri[itemp*4+0]=ip1[itemp];
                ri[itemp*4+1]=ip1[itemp];
                ri[itemp*4+2]=ip1[itemp];
                ri[itemp*4+3]=255;
            }
        }
        //brain=bstate;
        console.log(ri);
        brain.classify(ri,overtest);
    }

    let testbtn4 = ()=>{
        let ip1=camel.testing[0];
        let ri=[]
        for(let j=0;j<28;j++)
        {
            for(let k=0;k<28;k++)
            {
                let itemp=j*28+k;
                ri[itemp*4+0]=ip1[itemp];
                ri[itemp*4+1]=ip1[itemp];
                ri[itemp*4+2]=ip1[itemp];
                ri[itemp*4+3]=255;
            }
        }
        console.log("test input");
        console.log(ri);
        brain.classify(ri,overtest);
    }


    let testbtn54 = (p5)=>{
        
        let input=p5_loc.createGraphics(28,28);
        let i2=input.copy(canvas,0,0,canvas_width,canvas_width,0,0,28,28);
        p5_loc.image(input,0,0)
        console.log("key is presed");
        // console.log(input);
        // console.log(i2);
    }

    let testbtn5 = ()=>{
        let img=p5_loc.get();
        p5_loc.loadPixels();
        img.resize(28,28);          //this works
        img.loadPixels();
        
        let lasti=Array.prototype.slice.call(img.pixels)
        console.log(lasti);
        //brain=bstate;
        brain.classify(lasti,overtest);
    }

    let testbtn5_dummy = ()=>{
        let ip1=camel.testing[0];
        let ri=[]
        for(let j=0;j<28;j++)
        {
            for(let k=0;k<28;k++)
            {
                let itemp=j*28+k;
                ri[itemp*4+0]=ip1[itemp];
                ri[itemp*4+1]=ip1[itemp];
                ri[itemp*4+2]=ip1[itemp];
                ri[itemp*4+3]=255;
            }
        }
        // brain.classify(input,overtest);
    }

    let overtest= (err,results)=>{
        if(err)
        console.log(err)
        else
        console.log(results);
        // setGuess(results[0].label);
        console.log(results[0].label);
        // console.log(brain);
        // console.log("brain");

        let aa=document.querySelector(".guess_answer");
        aa.innerHTML=results[0].label;
    }
    
    let savebtn = ()=>{
        brain.save()
    }
    let loadbtn = ()=>{
        let modelInfo = {
            weights: 'saved_model_without_camel/model.weights.bin',
            model: 'saved_model_without_camel/model.json',
            metadata: 'saved_model_without_camel/model_meta.json',
          };
          brain.load(modelInfo, ()=>{console.log("loading over")});
        //   setBstate(brain);
          
    }

    function touchMoved(event) {
        console.log(event);
        console.log("touch detected");
      }


    let finishedTraining = ()=>{
            console.log("training over");
            return false;
    }


    let clearbtn =()=>{
        // keyPressed(p5_loc);
        p5_loc.clear();
         p5_loc.background(0);
        
    }


    return (
        <div 
        style={{overflowY:"hidden"}}
        >
            <div style={{textAlign:"center",margin:"20px 0",fontSize:"20px"}}>Doodle Guesser (cat, train, rainbow) </div>
            <div className="top_cont">
            <Sketch setup={setup} draw={draw}
            preload={preLoad}
            //  mousePressed={mousePressed} 
            keyPressed={keyPressed}
            testbtn5={testbtn5}
            touchMoved={touchMoved}
            className="sk_css"
              />
            {/* <div>The guess:  {guess}</div> */}
            <div className="guess_cont">
                <div>The guess is:   </div>
                <div className="guess_answer" style={{marginLeft:"5px"}}>__</div>
            </div>
            </div>
            
            <div className="btn_cont"
             style={{display:"none"}}
             >

              <button onClick={imgbtn}>view normalised data</button>
              <button onClick={databtn}>view  data</button>
              <button onClick={trainbtn}>train</button>
              <button onClick={testbtn}>test cat</button>
              <button onClick={testbtn2}>test train</button>
              <button onClick={testbtn3}>test rainbow</button>
              <button onClick={testbtn4}>test camel</button>
              <button onClick={testbtn5}>test drawing</button>
              <button onClick={savebtn}>save</button>
              <button onClick={loadbtn}>load</button>
            </div>

            <div className="btn_cont" 
            //  style={{display:"none"}}
             >

                <button onClick={testbtn5}>test drawing</button>
                <button onClick={clearbtn}>clear</button>
            </div>

            

            

        </div>
    )
}

export default Cnn2
